var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"message-text --text -mxy_0",attrs:{"data-testid":"text_message"},domProps:{"innerHTML":_vm._s(_vm.protectFromXSS(_vm.message))}})
}
var staticRenderFns = []

export { render, staticRenderFns }